<!--
 * @Description: 日志管理系统日志
 * @Author: xu wei
 * @Date: 2020-02-26 15:44:38
 * @LastEditTime: 2020-06-18 18:04:07
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>日志管理</el-breadcrumb-item>
        <el-breadcrumb-item>系统日志</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span>
            <el-button size="small" type="danger" @click="logclear">清除日志数据</el-button>
          </span>
        </li>
      </ul>
    </div> -->
    <div class="gs_tablebox">
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column type="index" width="60" label="编号">
        </el-table-column>
        <el-table-column prop="dateTime" label="访问时间">
        </el-table-column>
        <el-table-column label="访问IP">
          <template slot-scope="scope">
            <p style="color:#268000">{{scope.row.ip}}</p>
          </template>
        </el-table-column>
        <el-table-column label="访问地址">
          <template slot-scope="scope">
            <p style="color:#b03f3f">{{scope.row.location}}</p>
          </template>
        </el-table-column>
        <el-table-column prop="location" label="操作描述">
        </el-table-column>
        <el-table-column prop="userName" label="访问用户">
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      numberperpage: '', // 每页数量
      numberdrow: '', // 每页数量下拉
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      options: [],
      tableData: []
    };
  },
  methods: {
    // 日志列表
    async getlist() {
      this.$api.log
        .loglist({
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          } else if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 清除日志
    async logclear() {
      this.$api.log
        .logclear()
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('清除成功!');
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
</style>
